import { ReactElement } from "react";
import { Route, RouteComponentProps, useRouteMatch } from "react-router-dom";
import { useDependency } from "../../contexts/DependencyContext";
import { useTimeMachine } from "../../contexts/TimeMachineContext"
import { ViewTypeContextProvider } from "../../contexts/ViewTypeContext";
import { useRecurrentAsyncCall } from "../../hooks/UseAsyncCall";
import { ComponentModelService } from "../../services/ComponentModelService";
import { IComponentInfoResult } from "../../services/http/component/models/IComponentInfoResult";
import styles from "./DashboardPage.module.scss";
import SideNav from "./SideNav";
import DashboardSideBar from "./DashboardSideBar";
import FullscreenDashboardView from "./FullscreenDashboardView";
import DashboardView from "./DashboardView";
import TimeMachine from "./TimeMachine";

interface DashboardPageProps
{
    componentId: string;
}

async function loadData(service: ComponentModelService, componentId: string, timeMachineDate: Date): Promise<IComponentInfoResult>
{
    return await service.loadComponentModel(componentId, timeMachineDate);
}

function DashboardPage(props: RouteComponentProps<DashboardPageProps>): ReactElement
{
    const { path } = useRouteMatch();
    const service = useDependency(ComponentModelService);
    const timeMachine = useTimeMachine();
    let { loading, content } = useRecurrentAsyncCall(parseInt(process.env.REACT_APP_INFO_REFRESH_RATE ?? "300000"), loadData, service, props.match.params.componentId, timeMachine);
    content = content || service.componentModel;

    return (
        <main className={styles.wrapper}>
            {loading && <div className="loading" />}

            {/* TODO: Do we need this Context? To check with Ivan */}
            <ViewTypeContextProvider>
                <TimeMachine />
                <SideNav {...content} />

                <section className={styles.inner}>
                    <DashboardSideBar {...content} loading={loading} />
                    <Route path={`${path}/:widgetType/:widgetId`} component={FullscreenDashboardView} />
                    <Route path={`${path}`} component={DashboardView} exact />
                </section>
            </ViewTypeContextProvider>
        </main>
    );
};

export default DashboardPage;